import useAppTranslation from "@hooks/language/useAppTranslation";
import useUserStore from "@store/user.store";
import type { IAffiliateCardProps } from "./AffiliateLinkCard";
import CopyText from "./CopyText";
import ContainerCard from "./container/ContainerCard";
import ContainerText from "./container/ContainerText";

const AffiliateCodeCard: React.FC<IAffiliateCardProps> = ({
  containerProps,
}) => {
  const { affiliationInformation } = useUserStore();
  const { t } = useAppTranslation("pages.clientDashboard.components");

  return (
    <ContainerCard title={t("affiliateCodeCard.title")} {...containerProps}>
      <CopyText
        isGradient
        value={affiliationInformation?.affiliateCode ?? ""}
        classNames={{ root: "w-full", label: "text-primary-white" }}
      >
        {affiliationInformation?.affiliateCode ?? ""}
      </CopyText>
      <ContainerText className="text-center">
        {t("affiliateCodeCard.text")}
      </ContainerText>
    </ContainerCard>
  );
};

export default AffiliateCodeCard;
